import VCard from "vcard-creator";

// Header scrolling class
if (document.querySelector("header")) {
	const header = document.querySelector("header");

	function checkScroll() {
		let scrollTop = window.scrollY;

		if (scrollTop > 10) {
			header.classList.add("header-scrolling");
		} else {
			header.classList.remove("header-scrolling");
		}
	}

	checkScroll();
	window.addEventListener("scroll", checkScroll);
}

if (document.querySelector(".error404 .horse-neigh")) {
	const horseNeigh = document.querySelector(".error404 .horse-neigh");

	let clickCount = 0;
	const baseUrl = window.location.origin;
	const neighAudio = new Audio(baseUrl + '/wp-content/themes/Social-Sorbet-Child/assets/sounds/neigh.wav');

	horseNeigh.addEventListener('click', () => {
		clickCount++;
		if (clickCount === 8) {
			console.log("Neigh!");
			neighAudio.play();
			clickCount = 0;
		}
	});

}

if(document.querySelector(".vcard-button")) {
	const vCardButtons = document.querySelectorAll(".vcard-button")

	vCardButtons.forEach((vCardButton) => {
		vCardButton.addEventListener("click", (e) => {
			e.preventDefault();

			const [firstName = "", lastName = ""] = (vCardButton.dataset.name || "").split(" ", 2);
			const positionTitle = vCardButton.dataset.position || "";
			const phone = vCardButton.dataset.phone || "";
			const email = vCardButton.dataset.email || "";
			const linkedin = vCardButton.dataset.linkedin || "";
			const twitter = vCardButton.dataset.twitter || "";
			const url = window.location.origin + "/";

			const vCard = new VCard();

			vCard.addName(lastName, firstName, '', '', '')
				.addCompany('Strategic Claims Services');

			if (positionTitle) vCard.addJobtitle(positionTitle);
			if (email) vCard.addEmail(email);
			if (phone) vCard.addPhoneNumber(phone, 'PREF;WORK');
			if (linkedin) vCard.addSocial(linkedin, 'LinkedIn');
			if (twitter) vCard.addSocial(twitter, 'Twitter');
			vCard.addURL(url);

			const vCardBlob = new Blob([vCard.toString()], { type: "text/vcard" });
			const downloadLink = document.createElement("a");
			downloadLink.href = URL.createObjectURL(vCardBlob);
			downloadLink.download = `${firstName}_${lastName}.vcf`;
			document.body.appendChild(downloadLink);
			downloadLink.click();
			document.body.removeChild(downloadLink);
			URL.revokeObjectURL(downloadLink.href);
		});
	})
}